module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "title-box"
  }, [_c('div', {
    staticClass: "title-box-wrapper"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.t('All products from monitored categories')) + " "), (!_vm.own) ? _c('span', [_vm._v("(" + _vm._s(_vm.t('including competing producers')) + ")")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "bg"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "control-group"
  }, [_c('div', {
    staticClass: "controls form-inline"
  }, [_c('div', {
    staticClass: "pull-left",
    attrs: {
      "id": "datatable-search-box"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-left",
    attrs: {
      "id": "datatable-length-box"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-left"
  }, [_c('label', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category),
      expression: "category"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "category"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changeCategory(_vm.category)
      }]
    }
  }, _vm._l((_vm.categories), function(category) {
    return _c('option', {
      domProps: {
        "value": category.id
      }
    }, [_vm._v("\n                                                " + _vm._s(category.name) + "\n                                            ")])
  }), 0)]), _vm._v(" "), _vm._l((_vm.attributes), function(attribute) {
    return _c('label', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filter[attribute.id]),
        expression: "filter[attribute.id]"
      }],
      staticClass: "form-control",
      attrs: {
        "name": attribute.id
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.filter, attribute.id, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "0"
      }
    }, [_vm._v(_vm._s(attribute.name))]), _vm._v(" "), _vm._l((attribute.values), function(value) {
      return _c('option', {
        domProps: {
          "value": value.id
        }
      }, [_vm._v("\n                                                " + _vm._s(value.name) + "\n                                            ")])
    })], 2)])
  }), _vm._v(" "), _c('label', [_c('price-range', {
    attrs: {
      "interval": 2000
    },
    on: {
      "update": _vm.updatePriceRange
    },
    model: {
      value: (_vm.priceRange),
      callback: function($$v) {
        _vm.priceRange = $$v
      },
      expression: "priceRange"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-confirm",
    on: {
      "click": function($event) {
        _vm.showFilters = false;
        _vm.initDT();
      }
    }
  }, [_vm._v(_vm._s(_vm.t('Filter')))])], 2)])])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "table-wrapper"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('form', {
    staticClass: "form-inline",
    attrs: {
      "action": _vm.$http.options.root + '/reports/dump/' + _vm.category,
      "method": "get",
      "target": "_blank"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "own"
    },
    domProps: {
      "value": _vm.own
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "category"
    },
    domProps: {
      "value": _vm.category
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "search"
    },
    domProps: {
      "value": _vm.searchValue
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "report"
    },
    domProps: {
      "value": _vm.report
    }
  }), _vm._v(" "), _vm._l((_vm.attributes), function(attribute) {
    return _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filter[attribute.id]),
        expression: "filter[attribute.id]"
      }],
      staticClass: "form-control hide",
      attrs: {
        "name": 'filter[' + attribute.id + ']'
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.filter, attribute.id, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "0"
      }
    }, [_vm._v("-")]), _vm._v(" "), _vm._l((attribute.values), function(value) {
      return _c('option', {
        domProps: {
          "value": value.id
        }
      }, [_vm._v("\n                            " + _vm._s(value.name) + "\n                        ")])
    })], 2)
  }), _vm._v(" "), _vm._l((_vm.rule.conditions), function(condition_item, index) {
    return _c('div', _vm._l((condition_item), function(cond, key) {
      return _c('input', {
        attrs: {
          "type": "hidden",
          "name": 'conditions[' + index + '][' + key + ']'
        },
        domProps: {
          "value": cond
        }
      })
    }), 0)
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-confirm btn-sm",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.t('Export')))])], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5722b652!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DataGrid.vue
// module id = 1294
// module chunks = 2